import { TOGGLE_MODE } from "../actions/constants";

export const toggleModeReducer = (state = true, { type }) => {
    switch (type) {
        case TOGGLE_MODE:
            return !state;
        default:
            return state;
    }
};
